export const FinRegEDevConfig = {
  baseAppURL: 'api',
  tokenKey: '__accesstoken',
  AUTH_API_TOKEN: 'KHy5Fxyr9t62iQUycQdHAsOjaM0Ud2DkihdLzgm0vzYTUISFNgdBKg=='
};
